import { useCallback, useEffect, useMemo, useState } from 'react';
import { roles } from '../model/types';
import { isAdminOrAgent } from '../utils/accountHelper';
//TODO: utku add types

const DEFAULT_SIZE_LIMIT = 7;
const ADMIN_OR_AGENT_SIZE_LIMIT = DEFAULT_SIZE_LIMIT;
const END_USER_SIZE_LIMIT = 50;
export default function useFileSizeCompare(role: roles): { compareFn: typeof returnFunction; fileSizeLimit: number } {
    const [fileSizeLimit, setFileSizeLimit] = useState(DEFAULT_SIZE_LIMIT);
    useEffect(() => {
        //Check the role and set the fileSizeLimit appropriate value.
        if (isAdminOrAgent(role)) setFileSizeLimit(ADMIN_OR_AGENT_SIZE_LIMIT);

        //set size limit to END_USER_SIZE_LIMIT, so that we can be safe to use it for un-authenticated users (end_users)
        setFileSizeLimit(END_USER_SIZE_LIMIT);
    }, [role]);

    // Return a Function with a single parameter File Size and compare's it with fileSizeLimit and returns a boolean
    const returnFunction = useCallback(
        (fileSize: number) => {
            return fileSize > fileSizeLimit;
        },
        [fileSizeLimit]
    );

    return useMemo(
        () => ({
            compareFn: returnFunction,
            fileSizeLimit: fileSizeLimit
        }),
        [returnFunction, fileSizeLimit]
    );
}

export { ADMIN_OR_AGENT_SIZE_LIMIT, DEFAULT_SIZE_LIMIT, END_USER_SIZE_LIMIT };
